import { render, staticRenderFns } from "./MonitorScoreExamForm.vue?vue&type=template&id=00c08c7f&"
import script from "./MonitorScoreExamForm.vue?vue&type=script&lang=js&"
export * from "./MonitorScoreExamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports